module.exports = __webpack_public_path__ + "cog.18d96796365b31959d61554af69b1dcf.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/cog.svg
// module id = 1659
// module chunks = 39